import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { consumeSavedRoute } from "@/lib/auth/redirectFallback";

/**
 * Al volver del redirect de Microsoft (login inicial o renovacion de token),
 * restaura la ruta guardada por saveCurrentRoute. No renderiza nada.
 *
 * Espera a que MSAL termine de procesar el redirect: `isAuthenticated` ya es
 * true con la cuenta cacheada, y el `navigate(replace)` reescribe la URL sin
 * el `#code=...` que MSAL todavia no ha leido (los efectos de los hijos corren
 * antes que el del MsalProvider, que es quien lo lee).
 */
export default function RedirectRestore() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || inProgress !== InteractionStatus.None) return;
    const route = consumeSavedRoute();
    if (route && route !== window.location.pathname + window.location.search) {
      navigate(route, { replace: true });
    }
  }, [isAuthenticated, inProgress, navigate]);

  return null;
}
